/* raw layout hash: _default-web-layout-1rckt4r:c3b027bcfd56cf5d4b75da90cdb80f5198e709d9ff5d01afb5284a2a672333b1 */
import React from "react";
import AppShell from "./AppShell.jsx";

// Layout "_default-web-layout-1rckt4r" (RawHTMLDesign/layouts/_default-web-layout-1rckt4r.html)
export default function DefaultWebLayout1rckt4r({ children }) {
  return <AppShell menuKey="set5">{children}</AppShell>;
}
